import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';

export function AdminRoute() {
  const { user } = useAuth();

  if (!user?.isAdministrator) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
